import { Color, IconButton, Tag, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import type { ReviewEntryQuestion } from '../../../../../../types/reviewEntryQuestion'
import * as Styled from './styles'

interface ReviewEntryClarificationCardProps {
  onDismiss: () => void
  question: ReviewEntryQuestion
}

const getQuestionText = (question: ReviewEntryQuestion): string =>
  question.content?.trim() || question.message?.trim() || ''

export const ReviewEntryClarificationCard = ({
  onDismiss,
  question,
}: ReviewEntryClarificationCardProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Styled.ReviewEntryClarificationCardWrapper data-testid="review-entry-clarification-card">
      <Styled.ReviewEntryClarificationCardClose>
        <IconButton aria-label={t('review_entries.detail.clarification.close')} icon="x" onClick={onDismiss} />
      </Styled.ReviewEntryClarificationCardClose>
      <Styled.ReviewEntryClarificationCardTag>
        <Tag color="yellow" icon="circleQuestionMark" size="sm" type="subtle">
          {t('review_entries.detail.clarification.tag', { count: 1 })}
        </Tag>
      </Styled.ReviewEntryClarificationCardTag>
      <Text color={Color.Grey800} variant="bodyLG" weight="medium">
        {getQuestionText(question)}
      </Text>
    </Styled.ReviewEntryClarificationCardWrapper>
  )
}
